import React, { useCallback } from 'react'

import { DeleteDialog } from '@/components/library-v2/ui/DeleteDialog'

import { useDeleteCatalogEntries } from '@/hooks/library/useDeleteCatalogEntries'
import { useActiveOrgId } from '@/hooks/organization/useActiveOrgId'

import { UUID } from '@/types/Id'

interface DeleteEntriesDialogProps {
  catalogEntryIds: UUID[]
  schemaId?: UUID
  open: boolean
  setOpen: (isOpen: boolean) => void
  onDelete?: () => void
}

export const DeleteEntriesDialog: React.FC<DeleteEntriesDialogProps> = ({
  catalogEntryIds,
  schemaId,
  open,
  setOpen,
  onDelete,
}) => {
  const { activeOrgId } = useActiveOrgId()
  const { mutate: deleteCatalogEntries } = useDeleteCatalogEntries({
    orgId: activeOrgId,
    schemaId,
    invalidateActiveQueriesOnSuccess: false,
  })

  const onSubmit = useCallback(() => {
    try {
      if (catalogEntryIds.length > 0) {
        deleteCatalogEntries({ ids: catalogEntryIds })
      }
      onDelete?.()
    } catch (error) {
      console.error(error)
    }
  }, [catalogEntryIds, deleteCatalogEntries, onDelete])

  return (
    <DeleteDialog
      label={
        catalogEntryIds.length === 1
          ? 'entry'
          : `${catalogEntryIds.length} entries`
      }
      open={open}
      setOpen={setOpen}
      onDelete={onSubmit}
    />
  )
}
